import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { AutosuggestProps } from '@amzn/awsui-components-react';
import { loadLocationSuggestions } from '../../../hooks/locations';
import Autosuggest from '@amzn/awsui-components-react/polaris/autosuggest';

import { useSearchParams } from 'react-router-dom';
import { useFeatures, getEnabledFeatures } from '../../../hooks/features';

export interface LocationAutosuggestProps {
  currentLocation: string;
  onChange: NonNullable<AutosuggestProps['onChange']>;
  eventType: 'on-campus' | 'off-campus' | 'virtual';
  error?: string;
}

export function LocationAutosuggest({
  currentLocation,
  onChange,
  eventType,
  error,
}: LocationAutosuggestProps) {
  const namespaces = ['attendance', 'translation'];
  const { t } = useTranslation(namespaces);
  const [options, setOptions] = useState<AutosuggestProps.Options>([]);
  const [status, setStatus] = useState<AutosuggestProps.StatusType>();
  const [searchParams] = useSearchParams();
  const features = useFeatures();

  const loadLocationOptions = async (filteringText: string) => {
    // Location autocomplete api only loads with 2+ characters
    if (filteringText.length > 1) {
      try {
        setStatus('loading');
        setOptions([]);
        const result = await loadLocationSuggestions(
          filteringText,
          eventType,
          getEnabledFeatures(features, searchParams)
        );
        setOptions(result.options);
        setStatus('finished');
      } catch (e) {
        setStatus('error');
      }
    } else {
      setOptions([]);
    }
  };

  return (
    <Autosuggest
      filteringType="manual"
      value={currentLocation}
      onChange={(event) => {
        onChange(event);
      }}
      placeholder={
        eventType === 'on-campus'
          ? t('additionalInfo.searchBuildingCodes')
          : t('additionalInfo.searchOrEnterLocation')
      }
      statusType={status}
      options={options}
      empty={t('additionalInfo.noLocationSuggestions')}
      loadingText={t('additionalInfo.loadingLocationSuggestions')}
      errorText={error}
      onLoadItems={({ detail }) => {
        loadLocationOptions(detail.filteringText);
      }}
      invalid={error !== undefined}
      expandToViewport
    />
  );
}
